import React from 'react';
import { GraduationCap, Building2, DollarSign } from 'lucide-react';
import { useIsMobile } from '../../hooks/useIsMobile';

const G = '#0F5A3A';
const GOLD = '#F5B327';

const STATS = [
  { icon: <GraduationCap size={20} color={G} />, value: '1M+', label: 'Active Students' },
  { icon: <Building2 size={20} color={G} />, value: '2,500+', label: 'Partner Colleges' },
  { icon: <DollarSign size={20} color={G} />, value: '$500M+', label: 'Scholarships Connected' },
];

export const StatsRow = () => {
  const isMobile = useIsMobile();

  return (
    <section style={{ background: '#fff', borderBottom: '1px solid #f0ede8' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: isMobile ? '0 20px' : '0 40px' }}>
        {isMobile ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', padding: '20px 0', gap: '8px' }}>
            {STATS.map((s) => (
              <div key={s.label} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '12px 8px', borderRadius: '10px', background: `${G}05` }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '9px', background: `${G}0d`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px' }}>
                  {s.icon}
                </div>
                <div style={{ fontSize: '1.1rem', fontWeight: 900, color: G, letterSpacing: '-0.02em', lineHeight: 1, fontFamily: 'Playfair Display, serif' }}>{s.value}</div>
                <div style={{ fontSize: '10px', color: '#7E7972', marginTop: '3px', lineHeight: 1.3 }}>{s.label}</div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', height: '88px' }}>
            <div style={{ display: 'flex', alignItems: 'center', flex: '0 0 auto' }}>
              {STATS.map((s, i) => (
                <React.Fragment key={s.label}>
                  {i > 0 && <div style={{ width: '1px', height: '44px', background: '#e8e4df', flexShrink: 0, margin: '0 32px' }} />}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: `${G}0d`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {s.icon}
                    </div>
                    <div>
                      <div style={{ fontSize: '1.4rem', fontWeight: 900, color: G, letterSpacing: '-0.02em', lineHeight: 1, fontFamily: 'Playfair Display, serif' }}>{s.value}</div>
                      <div style={{ fontSize: '12px', color: '#7E7972', marginTop: '2px', whiteSpace: 'nowrap' }}>{s.label}</div>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
            <div style={{ width: '1px', height: '56px', background: '#e8e4df', flexShrink: 0, margin: '0 36px' }} />
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div style={{ display: 'flex', flexShrink: 0 }}>
                {['#a8d8a8','#7bc47b','#5aad5a'].map((c, i) => (
                  <div key={i} style={{ width: '30px', height: '30px', borderRadius: '50%', background: c, border: '2px solid #fff', marginLeft: i > 0 ? '-8px' : 0, boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }} />
                ))}
              </div>
              <div style={{ minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: '13px', color: '#4A5568', lineHeight: 1.55, fontStyle: 'italic', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '480px' }}>
                  &ldquo;Student Signal helped me find the perfect college and a scholarship. It changed my future.&rdquo;
                </p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                  <span style={{ fontSize: '12px', fontWeight: 700, color: G }}>Jasmine R.</span>
                  <span style={{ fontSize: '11px', color: '#999' }}>Class of 2026</span>
                  <div style={{ display: 'flex', gap: '1px', marginLeft: '2px' }}>
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} width="11" height="11" viewBox="0 0 10 10" fill={GOLD}><path d="M5 0.5l1.12 2.27 2.51.36-1.82 1.77.43 2.5L5 6.17l-2.24 1.18.43-2.5L1.37 3.13l2.51-.36z"/></svg>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default StatsRow;
